import { ReactElement } from 'react';

import { Accordion, AccordionDetails, AccordionSummary, ExpandMoreIcon } from '@methanesat/ui-components';
import { MapControlAccordionProps } from '../../types';

/** Wrapper for expandable forms that update map layers.
 * Used in MultipleLayerDataDrawer.
 */
export const MapControlAccordion = ({
    children,
    expanded,
    HeaderContents,
    ...otherProps
}: MapControlAccordionProps): ReactElement => {
    return (
        <Accordion elevation={0} {...otherProps} expanded={expanded}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ paddingX: 1 }}>
                {HeaderContents}
            </AccordionSummary>
            {children && <AccordionDetails sx={{ paddingX: 1 }}>{children}</AccordionDetails>}
        </Accordion>
    );
};
